import AboutUsSection from './components/AboutUsSection';
import AttorneySpotlight from './components/AttorneySpotlight';
import CallToActionSection from './components/CallToActionSection';
import Footer from './components/Footer';
import Header from '../../components/ui/Header';
import { Helmet } from 'react-helmet';
import HeroSlider from './components/HeroSlider';
import PracticeAreasGrid from './components/PracticeAreasGrid';
import React from 'react';
import WhyChooseUsSection from './components/WhyChooseUsSection';

const Homepage = () => {
	return (
		<>
			<Helmet>
				<title>Fepa Law Partners - Excellence in Advocacy | Premier Legal Services</title>
				<meta
					name='description'
					content="Fepa Law Partners delivers unparalleled legal representation with 25+ years of experience. Trusted counsel for life's most important matters. Schedule your consultation today."
				/>
				<meta
					name='keywords'
					content='legal services, law firm, attorneys, corporate law, personal injury, criminal defense, legal consultation'
				/>
				<meta property='og:title' content='Fepa Law Partners - Excellence in Advocacy' />
				<meta
					property='og:description'
					content='Premier legal services combining sophisticated expertise with unwavering commitment to client success.'
				/>
				<meta property='og:type' content='website' />
				<link rel='canonical' href='/homepage' />
			</Helmet>

			<div className='min-h-screen bg-background'>
				<Header />

				<main>
					{/* Hero Section */}
					<HeroSlider />

					{/* About Us Section */}
					<AboutUsSection />

					{/* Practice Areas Section */}
					<PracticeAreasGrid />

					{/* Call to Action Section */}
					<CallToActionSection />

					{/* Why Choose Us Section */}
					<WhyChooseUsSection />

					{/* Attorney Spotlight Section */}
					<AttorneySpotlight />
				</main>

				<Footer />
			</div>
		</>
	);
};

export default Homepage;
